// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
// element按需引用
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/base.css';

import '@/assets/css/mStyle.css'
import allJs from '@/assets/js/allJs'
import {
  fetch
} from './axios'
Vue.use(allJs)
Vue.use(ElementUI)


router.beforeEach((to, from, next) => {
  if (!to.meta.isToken) {
    let token = store.getters.token;
    if (token) {
      next();
    } else {
      next({
        path: "/login"
      });
    }
  } else {
    next();
  }
})
Vue.config.productionTip = false
Vue.prototype.$fetch = fetch

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js